/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type StorefrontContactButton_seller$ref = any;
export type StorefrontContactButton_seller = {
    readonly serviceId: string | null;
    readonly " $refType": StorefrontContactButton_seller$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "StorefrontContactButton_seller",
    "type": "Seller",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = 'e40e078ed7e25c3329a991d14ec00f41';
export default node;
